//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssemblyPart",1,0],[0,"Description",1,0],[0,"FeatureName",1,0],[0,"Form",1,0],[0,"ItemType",1,0],[0,"Material",1,0],[0,"Name",1,0],[0,"SaProject",1,0],[0,"SectionNumber",1,0],[0,"Size",1,0],[1,"SteelBodies",0,"SelectBodyList",0],[0,"SubComponent",1,0],[0,"TemplateCategoryName",1,0],[0,"TemplateName",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.ShipDesign.SteelDistributionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SteelDistributionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SteelDistributionBuilder.SaName = Object.freeze({
    "FirstValue" : "FirstValue"});

SPLM.Features.ShipDesign.SteelDistributionBuilder.SaType = Object.freeze({
    "FirstValue" : "FirstValue"});

SPLM.Features.ShipDesign.SteelDistributionBuilder.SaSize = Object.freeze({
    "FirstValue" : "FirstValue"});

SPLM.Features.ShipDesign.SteelDistributionBuilder.SaMaterial = Object.freeze({
    "FirstValue" : "FirstValue"});

SPLM.Features.ShipDesign.SteelDistributionBuilder.SaForm = Object.freeze({
    "FirstValue" : "FirstValue"});

export default SPLM;